import React, { forwardRef, FC } from "react";
import * as StyledSystem from "styled-system";
import Box, { BoxProps } from "../box/Box";

export interface IGrid {
  templateColumns?: StyledSystem.GridTemplateColumnsProps["gridTemplateColumns"];
  gap?: StyledSystem.GridGapProps["gridGap"];
  rowGap?: StyledSystem.GridRowGapProps["gridRowGap"];
  columnGap?: StyledSystem.GridColumnGapProps["gridColumnGap"];
  autoFlow?: StyledSystem.GridAutoFlowProps["gridAutoFlow"];
  autoRows?: StyledSystem.GridAutoRowsProps["gridAutoRows"];
  autoColumns?: StyledSystem.GridAutoColumnsProps["gridAutoColumns"];
  templateRows?: StyledSystem.GridTemplateRowsProps["gridTemplateRows"];
  templateAreas?: StyledSystem.GridTemplateAreasProps["gridTemplateAreas"];
  area?: StyledSystem.GridAreaProps["gridArea"];
  column?: StyledSystem.GridColumnProps["gridColumn"];
  row?: StyledSystem.GridRowProps["gridRow"];
}

export type GridProps = BoxProps & IGrid;

const Grid: FC<GridProps> = forwardRef(
  (
    {
      gap,
      rowGap,
      columnGap,
      autoFlow,
      autoRows,
      autoColumns,
      templateRows,
      templateColumns,
      templateAreas,
      area,
      column,
      row,
      ...props
    },
    ref,
  ) => {
    return (
      <Box
        ref={ref}
        display="grid"
        gridArea={area}
        gridTemplateAreas={templateAreas}
        gridGap={gap}
        gridRowGap={rowGap}
        gridColumnGap={columnGap}
        gridAutoColumns={autoColumns}
        gridColumn={column}
        gridRow={row}
        gridAutoFlow={autoFlow}
        gridAutoRows={autoRows}
        gridTemplateRows={templateRows}
        gridTemplateColumns={templateColumns}
        {...props}
      />
    );
  },
);

Grid.displayName = "Grid";

export default Grid;
